// Catálogo de formas de empezar una página nueva (catálogo compartido —
// convención del panel: nada de arrays inline en las pantallas). Lo consume
// PageCreateForm. Cada opción decide cómo se rellenan los bloques iniciales:
//   - 'blank'    → página vacía (flujo clásico)
//   - 'template' → esqueleto fijo con copy generado por IA (POST /api/ai/page)
//   - 'describe' → el usuario describe la página y la IA elige bloques + textos

export type PageStartMode = 'blank' | 'template' | 'describe';
export type PageTemplateKey = 'about' | 'services' | 'contact' | 'landing';

export interface PageStartOption {
  id: string;
  label: string;
  description: string;
  mode: PageStartMode;
  templateKey?: PageTemplateKey;
  icon: string; // nombre de icono lucide
}

export const PAGE_START_OPTIONS: PageStartOption[] = [
  { id: 'about',    label: 'Sobre nosotros', description: 'Tu historia, misión y valores.',          mode: 'template', templateKey: 'about',    icon: 'users' },
  { id: 'services', label: 'Servicios',      description: 'Lo que ofreces, listo para mostrar.',      mode: 'template', templateKey: 'services', icon: 'briefcase' },
  { id: 'contact',  label: 'Contacto',       description: 'Datos y formulario para que te escriban.', mode: 'template', templateKey: 'contact',  icon: 'mail' },
  { id: 'landing',  label: 'Aterrizaje',     description: 'Página persuasiva para una campaña.',      mode: 'template', templateKey: 'landing',  icon: 'rocket' },
  { id: 'describe', label: 'Descríbela tú',  description: 'Cuéntanos qué quieres y la armamos.',      mode: 'describe', icon: 'sparkles' },
  { id: 'blank',    label: 'En blanco',      description: 'Empieza desde cero y arma tú los bloques.', mode: 'blank',    icon: 'square' },
];
